import { useMemo } from 'react';
import { any, propEq, propOr, pathOr, path } from 'ramda';

import {
  CORRESPONDENCE,
  OTHER_CONTACTS,
  PATIENT,
  NO_REPORT,
  NURSING_HOME,
  usePatient,
  SUB_ORGANIZATION,
  AGENT,
  REPORT_ONLY,
  REFERRAL_PARTNER,
  CONTACT_NAMES,
  CONTACT_TYPE,
} from 'store/patients';
import { NO_PATIENT_REPORTS } from 'store/organizations';
import { RECOMMENDED, REFERRAL, useCurrentDiagnosis } from 'store/diagnoses';

const checkContact = propOr(false, CORRESPONDENCE);
const checkContacts = any(propEq(true, CORRESPONDENCE));

export const useContactsForPatient = (patientId) => {
  const patient = usePatient(patientId) || null;
  const referral = pathOr(false, [REFERRAL, RECOMMENDED], useCurrentDiagnosis() || {});
  const noPatientReports = useMemo(() => pathOr(false, [NURSING_HOME, SUB_ORGANIZATION, NO_PATIENT_REPORTS], patient), [patient]);

  return useMemo(
    () =>
      CONTACT_NAMES.filter(
        ({ id }) =>
          (id === PATIENT && !noPatientReports && patient && !patient[NO_REPORT]) ||
          (id === REFERRAL_PARTNER && referral === true) ||
          (id === CONTACT_TYPE ? checkContacts(propOr([], OTHER_CONTACTS, patient)) : checkContact(propOr({}, id, patient))) ||
          (id === AGENT && (path([AGENT, CORRESPONDENCE], patient) || path([AGENT, REPORT_ONLY], patient)))
      ).sort(({ id }) => (id === NURSING_HOME ? -1 : 1)),
    [patient, noPatientReports, referral]
  );
};
